import { getGridStringOperators, GridColDef, GridRenderCellParams } from '@mui/x-data-grid'
import { Link } from 'react-router-dom'
import { BasPracticeEntity } from 'src/entities/interfaces'
import i18n from 'src/services/language.service'
const filterOperators = getGridStringOperators().filter(({ value }) =>
  ['contains', 'equals', 'startsWith', 'endsWith' /* add more over time */].includes(value)
)

export const columns: GridColDef[] = [
  {
    field: 'firstName',
    headerName: i18n.t('USER_INFO.FIRST_NAME'),
    editable: false,
    sortable: false,
    flex: 1,
    filterOperators,
    renderCell: (params: GridRenderCellParams) => {
      return <Link to={`/users/edit/${params.id}`}>{params.formattedValue}</Link>
    }
  },
  {
    field: 'lastName',
    headerName: i18n.t('USER_INFO.LAST_NAME'),
    editable: false,
    sortable: false,
    flex: 1,
    filterOperators
  },
  {
    field: 'role',
    headerName: i18n.t('USER.ROLE'),
    editable: false,
    sortable: false,
    filterable: true,
    disableColumnMenu: true,
    flex: 1
  },
  {
    field: 'practice',
    headerName: i18n.t('PRACTICES.PRACTICE'),
    editable: false,
    sortable: false,
    filterable: true,
    filterOperators,
    flex: 1,
    renderCell: (params: GridRenderCellParams) => {
      return (
        <div className='flex flex-wrap gap-1 my-1'>
          {params.formattedValue &&
            params.formattedValue.length > 0 &&
            params.formattedValue.map((practice: BasPracticeEntity, index: number) => (
              <div title={practice?.name} className='customTableChip' key={index}>
                {practice?.name?.length > 40 ? practice?.name.slice(0, 40) + '...' : practice?.name}
              </div>
            ))}
        </div>
      )
    }
  },
  {
    field: 'actions',
    filterable: false,
    headerName: '',
    editable: false,
    sortable: false,
    flex: 0.5,
    disableColumnMenu: true,
    align: 'right',
    getApplyQuickFilterFn: undefined
  }
]
